exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infl-fe__style__nav___3YD3i {\n  display: flex;\n  flex-direction: row;\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 4px 0;\n}\n.infl-fe__style__actionsContainer___3uoKo {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n@media (max-width: 1024px) {\n.infl-fe__style__actionsContainer___3uoKo {\n    padding-right: 35px\n}\n  }\n", ""]);

// Exports
exports.locals = {
	"nav": "infl-fe__style__nav___3YD3i",
	"actionsContainer": "infl-fe__style__actionsContainer___3uoKo"
};